import { setIsDanskeBank, setIsNets } from './sentryTagger'
import { ReceiverResult } from '../types'
import { messagingService } from '../services/messagingService'

const danskeBankRedirect = () => document.location.href.includes('#code')
const netsRedirect = (getQueryStringParameters: any) =>
	!!getQueryStringParameters.naasconsentreference

export const receiveDefaultWithEventDispatcher = (
	getQueryStringParameters: any,
): ReceiverResult => {
	let consentCodeFromBankProviderOrBank: string | undefined

	if (getQueryStringParameters.code) {
		consentCodeFromBankProviderOrBank = getQueryStringParameters.code
	}

	if (netsRedirect(getQueryStringParameters)) {
		setIsNets(true)
		consentCodeFromBankProviderOrBank =
			getQueryStringParameters.naasconsentreference
		console.log(
			'Succesfully retrieved consent code for Nets',
			consentCodeFromBankProviderOrBank,
		)
	}

	//Should be removed once when danske bank is updated to redirect receiver and no applicants no longer have started a danske bank session with old redirect
	if (danskeBankRedirect()) {
		setIsDanskeBank(true)
		consentCodeFromBankProviderOrBank = document.location.href
			.split('#code=')[1]
			?.split('&')[0]
		console.log(
			'Succesfully retrieved consent code for Danske Bank',
			consentCodeFromBankProviderOrBank,
		)
	}

	if (consentCodeFromBankProviderOrBank) {
		console.log(
			'Succesfully retrieved consent code',
			consentCodeFromBankProviderOrBank,
		)
		messagingService.dispatch(
			consentCodeReceivedEvent(consentCodeFromBankProviderOrBank),
		)
		return { success: true, consentCode: consentCodeFromBankProviderOrBank }
	}

	console.error('Default resolver failed to retrieve consent code')
	messagingService.dispatch(
		failedReceivingConsentCodeEvent(getQueryStringParameters),
	)
	return { success: false }
}

const consentCodeReceivedEvent = (consentCode: string) => {
	const eventTopic = 'transactionClientApp/consentCodeReceived'
	return { event: eventTopic, payload: { consentCode } }
}

const failedReceivingConsentCodeEvent = (queryParameters: any) => {
	const eventTopic = 'transactionClientApp/consentCodeReceivedFailed'
	return { event: eventTopic, payload: { queryParameters } }
}
